import { useTranslation } from "react-i18next";

export const FormInput = ({
  label,
  value,
  type = "text",
  min = 0,
  required = true,
  onChange,
  warning,
}) => {
  const { t } = useTranslation();
  return (
    <div className="form-group">
      <label className={`input-label ${required && "required"}`}>
        {t(`forms.type.vehicle.labels.${label}`)} {!required && `(${t("general.optional")})`}
      </label>
      <div className="input-cont">
        {warning ? (
          <div>
            <span style={{ color: "red", fontSize: "14px" }}>({warning})</span>
            <input
              value={value}
              data-testid={label}
              id={label}
              name={label}
              min={min}
              placeholder={t(`forms.type.vehicle.labels.${label}`)}
              max={5000000}
              className="text-input"
              type={type}
              onChange={onChange}
              required={required}
            />
          </div>
        ) : (
          <input
            value={value}
            data-testid={label}
            id={label}
            name={label}
            min={min}
            placeholder={t(`forms.type.vehicle.labels.${label}`)}
            max={5000000}
            className="text-input"
            type={type}
            onChange={onChange}
            required={required}
          />
        )}
      </div>
    </div>
  );
};

export const FormSelect = ({
  options,
  label,
  value,
  onChange,
  required = true,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className="form-group">
      <label className={`input-label ${required && "required"}`}>
        {t(`forms.type.vehicle.labels.${label}`)}
      </label>
      <div className="input-cont">
        <select
          disabled={disabled}
          onChange={onChange}
          value={value}
          className="text-input"
          name={label}
          required={required}
          data-testid={label}
        >
          <option value="" disabled selected>
            {t(`forms.type.vehicle.select.${label}.default`)}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option}>
              {t(`forms.type.vehicle.select.${label}.${option}`)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
